define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action",
	"csi/action/Aggregate",
	"csi/action/FormData",
	"csi/heading/AggregateController",
	"csi/locale",
	"csi/table/Widget",
	"csi/widget/MessageDialog",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"ProductSpec/SizeChart",
	"ProductSpec/SizeChart/UnitsTable"
], function(declare, lang, action, Aggregate, FormData, AggregateController, locale, Widget, MessageDialog, ActionControllerMixin, xml, SizeChart, UnitsTable) {

	return declare([AggregateController, ActionControllerMixin], {
		// FormData: form data for dimensions page
		_fdDimensions: null,

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			var nPage = wizard.getIndexOfPage(nextPage);
			var bRefresh = false;
			var fd, dfd;

			switch (nPage) {
				// SELECT PRODUCT GROUP
				case 0: {
					// use controller's form data to select product group
					fd = this.m_formData;
					fd.m_bRequireOne = true;
					break;
				}

				// SELECT DIMENSIONS FROM PRODUCT GROUP
				case 1: {
					var group = this.m_formData.getSelectedNode(true);

					// initialize form data to select dimensions if not already done (unless finishing)
					fd = this._fdDimensions;

					if (!fd && !bFinish) {
						fd = this._fdDimensions = new FormData(this);
						fd.m_bOmitSelections = true;
						fd.m_bRequireOne = true;
						fd.setAction(lang.mixin(new Aggregate(), {aggregateId: "Dimensions"}));
					}

					// if form data node has changed, then reset selections and refresh view
					if (fd && (fd.getNode() != group)) {
						fd.resetSelections();
						fd.setNode(group);
						bRefresh = true;
					}

					break;
				}
			}

			// set form data for next page in wizard and refresh view if necessary
			if (fd && !bFinish) {
				dfd = wizard.setFormDataToPage(nextPage, fd, bRefresh);
			}

			return dfd;
		},

		toWriterRequest: function() {
			// summary: add selected dimensions to request if any
			const {_fdDimensions, newValue} = this;
			const call = this.inherited(arguments);

			if (_fdDimensions) {
				this._bWrite = false;
				this._processFormData(_fdDimensions);
				this._bWrite = true;
				call.addParameter(xml.PROP_AGGREGATE_ADDS, xml.ATTR_REFLIST, this.urlsAppended);

				// reset newValue as _processFormData will change it to a dimension value
				this.newValue = newValue;
			}

			this.setProgress();
			return call;
		},

		getConfirmButton: function() {
			return MessageDialog.BUTTON_CHANGE;
		},

		onConfirm: function(/*String*/key) {
			// summary: if configured to confirm action, then start now that confirmed
			if (key == MessageDialog.BUTTON_CHANGE) {
				AggregateController.prototype.publish.call(this);
			} else {
				this.postProcess();
			}
		},

		publish: function() {
			// summary: if SizeChart has a ProductGroup confirm action before changing/deselect ProductGroup
			var newProductGroupUrl = this.newValue;
			var oldProductGroupUrl = this.oldValue;

			if (oldProductGroupUrl != newProductGroupUrl && xml.isValidURL(oldProductGroupUrl)) {
				this.confirmAction({});
			}
			else {
				this.inherited(arguments);
			}
		},


		postProcessSuccess: function() {
			// summary: refresh views and caches as necessary
			var view = this.widget;

			this.inherited(arguments);

			// refresh store for increment selection
			var incHeading = view.defView.findHeading("SubrangeIncrement", false);
			if (incHeading) {
				view.refreshHeadingStore(incHeading);
			}

			// refresh dimensions
			SizeChart.postActionRefreshDimensions(this);
		},

		/**
		 * @override
		 * The form data passed here is for the product group (first page), and if we're processing the action then one must be selected (either new or same as before)
		 */
		_hasSelections(fd) {
			return this.inherited(arguments) || fd.hasAggregations();
		},
	});
});